import createSubmit from '../../Form/createSubmitButton.jsx'
import { name } from './MissionForm.jsx'

export default createSubmit(name)